import { render, staticRenderFns } from "./FlipBigIcon.vue?vue&type=template&id=73fb5886"
import script from "./FlipBigIcon.vue?vue&type=script&lang=js"
export * from "./FlipBigIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports